export const getNodeById = (nodeId, model) => {
  const node = model.nodes.find((node) => node.id === nodeId);

  if (!node) throw new Error(`can't find node with id ${nodeId}`);

  return node;
};

export default getNodeById;
